import { Kushki } from '@kushki/js';
import paymentConfig from '../configs/payment';

interface IKushkiConfig {
  merchantId: string;
  inTestEnvironment?: boolean;
  regional?: boolean;
}

const kushkiClient = new Kushki({ ...paymentConfig.kushki });

export const kushkiClientBuilder = (config: IKushkiConfig): Kushki =>
  new Kushki({ ...paymentConfig.kushki, ...config });

export default kushkiClient;
